var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPinLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_pin_link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG",
    fill: "#fff",
    stroke: "#f0f0f0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ic_link",
    transform: "translate(-0.917 10.002) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M8.22,16.273l-.025,0a.346.346,0,0,0-.2.094L6.646,17.718a1.521,1.521,0,0,1-2.151-2.151l1.433-1.433a1.512,1.512,0,0,1,.238-.194,1.535,1.535,0,0,1,.309-.157,1.462,1.462,0,0,1,.313-.077A1.481,1.481,0,0,1,7,13.692c.029,0,.058,0,.1,0a1.517,1.517,0,0,1,.977.439,1.5,1.5,0,0,1,.357.57.329.329,0,0,0,.4.211l.006,0s0,0,0,0a.326.326,0,0,0,.219-.4,1.893,1.893,0,0,0-.514-.856,2.2,2.2,0,0,0-1.2-.612c-.04-.006-.079-.013-.119-.017A2.155,2.155,0,0,0,7,13.015c-.054,0-.109,0-.161.006a2.107,2.107,0,0,0-.338.052c-.023,0-.044.01-.067.017a2.172,2.172,0,0,0-.407.152,2.145,2.145,0,0,0-.579.416L4.012,15.091a2.2,2.2,0,0,0-.637,1.556A2.2,2.2,0,0,0,7.122,18.2l1.364-1.364A.331.331,0,0,0,8.22,16.273Z",
    transform: "translate(0 -6.777)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M18.517,4.016a2.2,2.2,0,0,0-3.106,0l-1.33,1.33a.336.336,0,0,0,.211.572.339.339,0,0,0,.265-.1l1.332-1.328a1.521,1.521,0,0,1,2.151,2.151L16.608,8.078a1.512,1.512,0,0,1-.238.194,1.535,1.535,0,0,1-.309.157,1.462,1.462,0,0,1-.313.077,1.481,1.481,0,0,1-.213.015c-.029,0-.061,0-.1,0a1.5,1.5,0,0,1-1.32-.971.334.334,0,0,0-.4-.2.337.337,0,0,0-.236.428,1.908,1.908,0,0,0,.495.783h0l0,0a2.2,2.2,0,0,0,1.322.629,2.155,2.155,0,0,0,.232.013q.081,0,.163-.006a2.388,2.388,0,0,0,.4-.067,2.173,2.173,0,0,0,.407-.152,2.145,2.145,0,0,0,.579-.416l1.433-1.433a2.2,2.2,0,0,0,0-3.108Z",
    transform: "translate(-7.095)",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinLink);
export default __webpack_public_path__ + "static/media/ic_pin_link.9fc0b6ebaab1769c53101af5f5806c4b.svg";
export { ForwardRef as ReactComponent };